"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _reshowConstant = require("reshow-constant");
var isObject = function isObject(val) {
  return val != null && typeof val === "object" && (0, _reshowConstant.IS_ARRAY)(val) === false;
};
var mergeDefaultValue = function mergeDefaultValue(obj, defaultValue) {
  obj = obj || {};
  (0, _reshowConstant.KEYS)(defaultValue).forEach(function (key) {
    obj[key] = isObject(defaultValue[key]) ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultValue[key]), obj[key]) : null != obj[key] ? obj[key] : defaultValue[key];
  });
  return obj;
};
var _default = exports["default"] = mergeDefaultValue;
module.exports = exports.default;